export default __webpack_public_path__ + "static/media/alphabet-yellow-o.394ffd28.png";